import React, { useEffect, useState } from "react";
import { schApi } from "@/lib/schApi";
import TimeRangePicker, { halfHours } from "@/components/nds/windows/sch/TimeRangePicker";

/** Time picker for a new event: half-hour boxes, tap start + tap end or drag. With people picked it colors who's busy. */
export default function AvailabilityStrip({ residentIds, staffIds, start, end, excludeId, onPick }) {
  const [d, setD] = useState(null);
  const day = start ? start.slice(0, 10) : "";
  const key = `${day}|${residentIds.join(",")}|${staffIds.join(",")}`;
  useEffect(() => {
    if (!day || (!residentIds.length && !staffIds.length)) { setD(null); return; }
    const p = new URLSearchParams({ date: day, resident_ids: residentIds.join(","), staff_ids: staffIds.join(",") });
    if (excludeId) p.set("exclude_event_id", excludeId);
    let live = true;
    schApi.get(`/availability?${p}`).then((x) => live && setD(x)).catch(() => live && setD(null));
    return () => { live = false; };
  }, [key, excludeId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!day) return null;
  const names = d ? Object.fromEntries(d.people.map((p) => [p.id, p.name])) : {};
  const local = (iso) => new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "America/New_York" });
  const slots = d ? d.slots.map((x) => ({ t: local(x.start_time), free: x.free, badge: x.free ? "" : String(x.busy_ids.length),
    title: x.free ? "everyone free" : `busy: ${x.busy_ids.map((i) => names[i]).join(", ")}`, busy: x.busy_ids })) : halfHours();
  const st = start.slice(11, 16), en = end ? end.slice(11, 16) : "";
  const clashes = d ? [...new Set(slots.filter((x) => x.t >= st && x.t < (en || st)).flatMap((x) => x.busy || []))] : [];
  return (
    <div data-testid="sch-availability" className="border border-white/10 rounded-sm p-2 space-y-2">
      <div className="flex flex-wrap items-center gap-3 font-mono text-[10px] tracking-[0.16em] uppercase text-nex-muted">
        <span>Pick the time · {new Date(`${day}T12:00:00`).toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" })}{d ? ` · ${d.people.length} people` : ""}</span>
        <span className="inline-flex items-center gap-1"><i className="w-2.5 h-2.5 bg-emerald-500/70 inline-block" /> free</span>
        {d && <span className="inline-flex items-center gap-1"><i className="w-2.5 h-2.5 bg-red-500/70 inline-block" /> someone busy</span>}
        <span className="inline-flex items-center gap-1"><i className="w-2.5 h-2.5 bg-nex-gold inline-block" /> your time</span>
      </div>
      <TimeRangePicker slots={slots} start={st} end={en} testid="sch-time" onChange={(a, b) => onPick(`${day}T${a}`, `${day}T${b}`)} />
      {d && <p data-testid="sch-availability-summary" className={`text-xs ${clashes.length ? "text-red-300" : "text-emerald-300"}`}>
        {clashes.length ? `Busy at your chosen time: ${clashes.map((i) => names[i]).join(", ")}` : "Everyone picked is free at your chosen time."}</p>}
    </div>
  );
}
